<div class="skymiles-landing-page-relative-links">
  <div
    *ngFor="let link of content.links"
    class="skymiles-landing-page-relative-links__content"
  >
    <idp-image
      [content]="link.image"
      class="skymiles-landing-page-relative-links__content--img"
    ></idp-image>

    <idp-link
      [id]="link.id || '#'"
      [axLabel]="link.label"
      [label]="link.label"
      [actionUrl]="link.url"
      [labelSize]="'extra-large'"
      (click)="onLinkClick(link)"
      class="skymiles-landing-page-relative-links__content--link"
    ></idp-link>
  </div>
</div>
